import { render, staticRenderFns } from "./CompanyOmsUpload.vue?vue&type=template&id=3b226cbc&scoped=true&"
import script from "./CompanyOmsUpload.vue?vue&type=script&lang=js&"
export * from "./CompanyOmsUpload.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOmsUpload.vue?vue&type=style&index=0&id=3b226cbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b226cbc",
  null
  
)

export default component.exports